import { useEffect, useState } from "react";
import { financialModelingPrepApiKey } from "../keys";
import axios from 'axios';

export default function usePriceTarget(ticker) {
    const [priceTarget, setData] = useState([]);
    const [loading,setLoading] = useState(false)
    useEffect(() => {
      const fetchData = async () => {
        try {
          setLoading(true)
          const response = await axios.get(
            `https://financialmodelingprep.com/api/v4/price-target?symbol=${ticker}&apikey=${financialModelingPrepApiKey}
            `
          );
          setData(response.data);
        } catch (error) {
          console.error(error);
        }
        finally{ 
        setLoading(false)
        }
      };
  
      if (ticker) {
        fetchData();
      }
    }, [ticker]);
  
    return { priceTarget };
  }
  